<template>
  <div class="h-full overflow-auto" v-loading="pageLoading">
    <el-select
      class="mt-10px w-full"
      v-model="robotHost"
      size="medium"
      placeholder="请选择机器人"
      @change="robotChange"
    >
      <el-option
        v-for="(robot, index) in robots"
        :key="index"
        :label="robot.robotName"
        :value="robot.host"
      ></el-option>
    </el-select>

    <div class="mt-10px" v-if="!playbackList.length">
      <!-- <div class="h-170px bg-[#ccc] mb-10px" @click="showCameraDetail({})">
        <robot-player :cameraIp="'123'" :cameraPort="'456'"></robot-player>
      </div>
      <div class="h-170px bg-[#ccc] mb-10px" @click="showCameraDetail({})">
        <robot-player :cameraIp="'321'" :cameraPort="'654'"></robot-player>
      </div> -->
      <div class="h-170px bg-[#ccc] mb-10px" v-for="item of monitorList" :key="item.port" @click="showCameraDetail(item)">
        <robot-player :cameraInfo="item"></robot-player>
      </div>
    </div>
    <!-- 图片切换 -->
    <div class="mt-10px" v-if="playbackList.length">
      <img :src="playbackList[playbackIndex].cameraPhotoPath" class="h-200px" />
      <el-table
        :data="playbackList[playbackIndex].vpApparatusRecordList"
        height="200px"
        highlight-current-row
      >
        <el-table-column prop="deviceName" label="设备名称"></el-table-column>
        <el-table-column prop="createTime" label="识别时间"></el-table-column>
        <el-table-column prop="identifyType" label="识别类型">
          <template slot-scope="scope">{{
            typeMap[scope.row.identifyType] || scope.row.identifyType
          }}</template>
        </el-table-column>
        <el-table-column prop="deviceResult" label="识别结果"></el-table-column>
      </el-table>
    </div>
    <categoryTitle class="mt-10px mb-10px" title="巡检任务" />
    <div class="mt-10px text-[#fff] text-14px px-5px" v-loading="loading">
      <div
        v-for="(item, index) in taskList"
        :key="index"
        class="flex items-center border-b border-[#45f2eb33] py-10px"
      >
        <div class="flex-1 task-item cursor-pointer" @click="taskDetail(item)">
          <div class="task-item-top flex justify-between items-center mb-6px">
            <div class="font-bold">{{ item.taskName }}</div>
            <div>{{ item.progressStatusName }}</div>
          </div>
          <div class="task-item-bottom flex justify-between items-center text-[#fffc] text-12px">
            <div>{{ item.execTime }}</div>
            <div>{{ item.viewTypeName }}</div>
          </div>
        </div>
        <div class="ml-10px" @click="playHandle(item)">
          <i v-if="item.isPlay" class="el-icon-video-pause text-20px cursor-pointer"></i>
          <i v-else class="el-icon-video-play text-20px cursor-pointer"></i>
        </div>
      </div>
    </div>

    <el-pagination
      v-if="taskList.length"
      background
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getTableList()"
      :pager-count="5"
    >
    </el-pagination>

    <TaskDetailDialog
      v-if="detailShow"
      @close="detailShow = false"
      :detailInfo="detailInfo"
      :robotHost="robotHost"
    >
    </TaskDetailDialog>
    <camera-detail-dialog
      v-if="cameraDetailShow"
      @close="closeCameraDetail()"
      :cameraInfo="monitorDetailData"
    ></camera-detail-dialog>
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import { RobotApi } from '@wiz-api/huizhou2'
import { loadTransitionAction } from '@/utils/dynamicEffect/translation'
import TaskDetailDialog from './components/TaskDetailDialog'
import robotService from '../../../service/RobotService'
import RobotPlayer from './components/h5Player'
import CameraDetailDialog from './components/cameraDetailDialog'

const baseUrl = Wiz.GetModuleServer()
const robotApi = new RobotApi()
const signalR = require('@microsoft/signalr')

export default {
  name: 'robotList',
  props: {
    player: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    categoryTitle,
    TaskDetailDialog,
    RobotPlayer,
    CameraDetailDialog,
  },
  data() {
    return {
      pageLoading: false,
      robotConnection: null,
      autoDiscount: true,
      robotHost: null,
      robotInfo: {},
      robots: [],
      loading: false,
      taskList: [
        // { taskName: 1, execId: 31, execTime: '2022-01-10 10:00:00', viewTypeName: '实时', progressStatusName: '已完成', taskType: 1, isPlay: false },
        // { taskName: 2, execId: 33, execTime: '2022-01-10 10:00:00', viewTypeName: '实时', progressStatusName: '已完成', taskType: 1, isPlay: false },
      ],
      page: {
        total: 0,
        pageSize: 10,
        pageNo: 1,
      },
      detailShow: false,
      detailInfo: {},
      playInfo: {},
      playbackList: [],
      playbackIndex: 0,
      playbackTimer: null,
      typeMap: {
        1: '仪表识别',
        2: '音频分析',
        3: '红外测温',
        4: '局放检测',
        5: '可见光拍照',
        6: '热像仪拍照',
        7: '可见光录像',
        8: '热像仪录像',
        9: '甲烷遥测',
        10: '录音',
        11: '人员入侵检测',
        12: '安全帽检测',
        13: '三项测温',
        14: '状态一致性',
        15: '部队队列识别',
        16: '车辆违停识别',
        17: '军装穿戴检测',
        18: '异物检测',
        19: '皮带跑偏',
        20: '托辊脱落检测',
        21: '末端工业相机拍照',
        22: '局放检测-特高频',
        23: '局放检测-超声波',
        24: '局放检测-地电波',
        25: '明火检测',
        26: '烟雾识别',
        27: '液体滴漏',
        28: '漏气识别',
        29: '电缆掉落识别',
        30: '可逆胶带机漏油识别',
        31: '可逆胶带机托辊脱落识别',
        32: '防火泥封堵脱落识别',
        33: '电缆移出桥架外侧识别',
        34: '防毒口罩检测',
        35: '防护服检测',
        36: '撒料检测',
        37: '皮带边缘破损',
        38: '充电桩外壳绝缘检测',
        39: '充电桩显示屏故障检测-触碰',
        40: '充电桩显示屏故障检测-识别',
        41: '充电桩外观形体检测',
        42: '充电桩外皮破损检测',
        43: '燃油车占位识别',
      },
      monitorPortList: [
        {
          port: 41554,
          name: '可见光',
        },
        {
          port: 42554,
          name: '红外',
        },
      ], // 机器人监控port列表，现场固定每个机器人2个摄像头对应两个端口，41554：可见光；42554：红外
      monitorList: [],
      monitorDetailData: {},
      cameraDetailShow: false,
      canTransition: false,
    }
  },
  computed: {
    getKksCode() {
      return (kksCode) => {
        const prefix = kksCode.slice(0, 4)
        if (prefix === '6760') {
          return kksCode.slice(4, kksCode.length)
        }
        return kksCode
      }
    },
  },
  methods: {
    // 播放
    async playHandle(item) {
      if (!this.robotInfo.currentPtr) return

      item.isPlay = !item.isPlay
      this.playInfo = item
      if (item.isPlay) {
        this.taskList.forEach((task) => {
          if (task.execId !== item.execId) {
            task.isPlay = false
          }
        })
      }

      this.changeImg(item)

      if (item.isPlay) {
        const threeDimensionalPointEnd = this.robotInfo.threeDimensionalPointEnd
          ? JSON.parse(this.robotInfo.threeDimensionalPointEnd)
          : [0, 0, 0]
        const endPos = this.gTol(threeDimensionalPointEnd, this.robotInfo.aabbOffset)
        // const endPos = this.gTol([575.5034790039062, 447.5598449707031, -0.3009999990463257], this.robotInfo.aabbOffset)
        const moveTime = this.robotInfo.runSeconds || 60
        const pathList = [
          {
            time: 0,
            pos: [0, 0, 0],
          },
          {
            time: moveTime,
            pos: endPos,
          },
          {
            time: moveTime * 2,
            pos: [0, 0, 0],
          }
        ]
        const { mixer, clip, action } = await loadTransitionAction(
          this.robotInfo.currentPtr,
          'move',
          pathList,
          true
        )
        this.robotInfo.action = action
        this.robotInfo.mixer = mixer

        this.setCameraFollowPos([0, 0, 0], endPos)
      } else if (this.robotInfo.action) {
        const isPlaying = await this.player.Native.AnimationAction.isPlaying(this.robotInfo.action)
        if (isPlaying) {
          await this.player.Native.AnimationAction.stop(this.robotInfo.action)
        }
      }
    },

    // 设置相机朝前面看
    async setCameraFollowPos(startPos, endPos) {
      const vec = [startPos[0] - endPos[0], startPos[1] - endPos[1]]
      const normalizeVector = (v) => {
        const x = v[0]
        const y = v[1]
        const length = Math.sqrt(x * x + y * y)
        if (length === 0) {
          return [0, 0]
        }
        return [x / length, y / length]
      }
      const nor = normalizeVector(vec)

      const max = this.robotInfo.aabbWh[0] > this.robotInfo.aabbWh[1] ? this.robotInfo.aabbWh[0] : this.robotInfo.aabbWh[1]
      // 设置相机朝前面看
      this.player.Native.TargetFollow.setFollowThirdCurrentOffset(this.robotInfo.followObject, [
        nor[0] * max * 3,
        nor[1] * max * 3,
        this.robotInfo.aabbWh[2],
      ])
    },
    // 图片切换
    async changeImg(item) {
      if (this.playbackTimer) {
        clearInterval(this.playbackTimer)
        this.playbackTimer = null
      }
      if (item.isPlay) {
        await this.getTaskDetail(item)
        this.playbackIndex = 0
        if (this.playbackList.length > 1) {
          // 图片切换展示
          this.playbackTimer = setInterval(() => {
            if (this.playbackIndex < this.playbackList.length - 1) {
              this.playbackIndex += 1
            } else {
              this.playbackIndex = 0
            }
          }, 5000)
        }
      } else {
        this.playbackList = []
        this.playbackIndex = 0
      }
    },
    stopImgPlay() {
      if (this.playbackTimer) {
        clearInterval(this.playbackTimer)
        this.playbackTimer = null
      }
      this.playbackList = []
      this.playbackIndex = 0
    },
    // 任务详情--图片列表
    async getTaskDetail(task) {
      const [err, res] = await robotService.getRobotTaskDetail(this.robotHost, {
        pageNum: 1,
        pageSize: 50,
        robotId: 1,
        execId: task.execId,
      })
      if (!err && res && res.data && res.data.list) {
        res.data.list.forEach((item) => {
          if (item.cameraPhotoPath) {
            const arr = item.cameraPhotoPath.split('.')
            if (arr.length > 1) {
              // 按最后一个 "/" 分割路径
              const parts = arr[0].split('/')
              const lastPart = parts[parts.length - 1]
              const beforePart = parts.slice(0, parts.length - 1).join('/')
              const basePart = `${beforePart}/${encodeURIComponent(lastPart)}.${arr[1]}`
              item.cameraPhotoPath = `${this.robotHost}${basePart}`
            } else {
              item.cameraPhotoPath = `${this.robotHost}${item.cameraPhotoPath}`
            }
          }
          item.vpApparatusRecordList = item.vpApparatusRecordList || []
        })
        this.playbackList = res.data.list.filter((item) => {
          return item.cameraPhotoPath
        })
      }
    },
    // 销毁节点
    async destroyNode() {
      const robotInfo = JSON.parse(JSON.stringify(this.robotInfo))
      this.robotInfo = {}
      if (robotInfo.currentPtr) {
        await this.player.Native.TargetFollow.unfollow()
        const isPlaying = await this.player.Native.AnimationAction.isPlaying(robotInfo.action)
        if (isPlaying) {
          await this.player.Native.AnimationAction.stop(robotInfo.action)
        }
        this.player.Native.ModelTree.setItemVisible(robotInfo.item, true)
        await this.player.Native.NodeProxy.destroyNode(robotInfo.currentPtr)
        robotInfo.currentPtr = null
      }
    },
    // 机器人选择
    async robotChange() {
      this.pageLoading = true
      this.canTransition = false
      await this.invokeConnection('RemoveFromGroupAsync', this.robotInfo.robotId)
      this.stopImgPlay()
      this.playbackList = []
      this.playbackIndex = 0
      await this.destroyNode()
      this.robotInfo =
        this.robots.find((item) => {
          return item.host === this.robotHost
        }) || {}
      console.log('robotInfo', this.robotInfo)
      this.playInfo = {}
      await this.getToken()
      this.getMonitorData()
      this.search()
      await this.moveToRobot()
      this.pageLoading = false
    },
    async invokeConnection(type, data) {
      try {
        if (this.robotConnection?.state === 'Connected') {
          await this.robotConnection?.invoke(type, data)
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 视角定位到机器人
    async moveToRobot() {
      // this.robotInfo.threeDimensionalCode = '制氢站灭火器-01'
      // this.robotInfo.threeDimensionalCode = 'J0GAA35AT001'
      if (this.robotInfo.threeDimensionalCode) {
        const codeInfo = await this.player.Native.ModelTree.getItemByCode(
          this.getKksCode(this.robotInfo.threeDimensionalCode)
        )
        if (codeInfo && codeInfo.item) {
          this.robotInfo.item = codeInfo.item
          this.player.Native.Camera.moveToItem(codeInfo.item, 1)
          const subItemInfo = await player.Native.ModelTree.getItemInfo(codeInfo.item)
          console.log('code', this.getKksCode(this.robotInfo.threeDimensionalCode), 'codeInfo', codeInfo, 'subItemInfo', subItemInfo)
          if (codeInfo.guid && codeInfo.nodePtr) {
            this.robotInfo.currentPtr = codeInfo.nodePtr
          } else {
            this.robotInfo.currentPtr = await this.player.Native.ModelTree.convertToNode(
              codeInfo.item,
              false
            )
            await this.player.Native.ModelTree.createNodeItem(
              subItemInfo.parentItem,
              this.robotInfo.currentPtr,
              true,
              false
            )
            await this.player.Native.ModelTree.setItemVisible(codeInfo.item, false)
          }
          console.log('ptr', this.robotInfo.currentPtr, this.robotInfo.item)
          const aabb = await this.player.Native.ModelTree.calcItemAabb(codeInfo.item)
          const aabbOffset = [
            (aabb.aabb.max[0] - aabb.aabb.min[0]) / 2 + aabb.aabb.min[0],
            (aabb.aabb.max[1] - aabb.aabb.min[1]) / 2 + aabb.aabb.min[1],
            (aabb.aabb.max[2] - aabb.aabb.min[2]) / 2 + aabb.aabb.min[2],
          ]
          this.robotInfo.aabbOffset = aabbOffset
          const aabbWh = [
            aabb.aabb.max[0] - aabb.aabb.min[0],
            aabb.aabb.max[1] - aabb.aabb.min[1],
            aabb.aabb.max[2] - aabb.aabb.min[2],
          ]
          this.robotInfo.aabbWh = aabbWh
          // 相机跟随
          this.robotInfo.followObject = await this.player.Native.TargetFollow.follow({
            followNode: this.robotInfo.currentPtr,
            followType: 3,
            targetPosOffset: this.robotInfo.aabbOffset,
          })
          setTimeout(async () => {
            await this.invokeConnection('AddToGroupAsync', this.robotInfo.robotId)
            this.canTransition = true
          }, 3000)
        }
      }
    },
    gTol(pos, aabb) {
      const res = [pos[0] - aabb[0], pos[1] - aabb[1], aabb[2] - aabb[2]]
      return res
    },
    // 获取监控
    getMonitorData() {
      this.monitorList = []
      for (let i = 0; i < this.monitorPortList.length; i += 1) {
        this.monitorList.push({
          cameraIp: this.robotInfo.ip,
          cameraPort: this.monitorPortList[i].port,
          cameraName: this.monitorPortList[i].name,
          robotName: this.robotInfo.robotName,
        })
      }
    },
    search() {
      this.page.pageNo = 1
      this.getTableList()
    },
    async getTableList() {
      this.loading = true
      const [err, res] = await robotService.getRobotTask(this.robotHost, {
        robotId: 1,
        pageNum: this.page.pageNo,
        pageSize: this.page.pageSize,
      })
      if (!err && res && res.data) {
        res.data.list.forEach((item) => {
          item.isPlay = false
        })
        this.page.total = res.data.total
        this.taskList = res.data.list
      }
      this.loading = false
      this.playInfo = {}
    },
    async taskDetail(item) {
      this.detailInfo = item
      this.detailShow = true
    },
    async getToken() {
      const [err, res] = await robotService.getRobotToken(this.robotHost, {
        username: this.robotInfo.username,
        password: this.robotInfo.password,
      })
      console.log('robotToken', res)
      if (!err && res && res.token) {
        localStorage.setItem('robotToken', res.token)
      }
    },
    async getRobotList() {
      const [err, res] = await robotApi.getRobotConfig()
      if (!err && res) {
        res.forEach((item) => {
          item.host = `http://${item.ip}:${item.port}`
        })
        this.robots = res
        if (res.length) {
          this.robotHost = res[0].host
          this.robotInfo = res[0]
        }
      }
    },
    showCameraDetail(data) {
      this.monitorDetailData = data
      this.cameraDetailShow = true
    },
    closeCameraDetail() {
      this.cameraDetailShow = false
    },

    async initConenction() {
      // 建立连接
      const url = `${baseUrl}/robot-real-time-location`

      this.robotConnection = new signalR.HubConnectionBuilder()
        .withUrl(url, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .configureLogging(signalR.LogLevel.Information)
        .build()

      // 监听信息
      this.robotConnection.on('receiveLocation', async (data) => {
        if (this.robotInfo.currentPtr && !this.playInfo.isPlay && this.canTransition) {
          const currentPos = this.gTol(data, this.robotInfo.aabbOffset)
          // console.log('receiveLocation', data, currentPos)
          const currentTranslation = await this.player.Native.NodeProxy.localTranslation(this.robotInfo.currentPtr)
          const pathList = [
            {
              time: 0,
              pos: currentTranslation,
            },
            {
              time: 1,
              pos: currentPos,
            },
          ]
          const { mixer, clip, action } = await loadTransitionAction(
            this.robotInfo.currentPtr,
            'move',
            pathList,
            false
          )
          this.robotInfo.action = action
          this.robotInfo.mixer = mixer
        }
      })

      this.robotConnection.onclose(() => {
        if (this.autoDiscount) {
          setTimeout(() => {
            this.reStartConnect()
          }, 5000)
        }
      })

      // 开始连接
      try {
        await this.robotConnection.start()
      } catch (e) {
        // console.log(e)
      }
    },
    async reStartConnect() {
      // 开始连接
      try {
        await this.robotConnection.start()
      } catch (e) {
        setTimeout(() => {
          this.reStartConnect()
        }, 5000)
      }
    },
    // 断开socket连接
    async disConnect() {
      if (this.robotConnection) {
        try {
          this.autoDiscount = false
          await this.robotConnection.stop()
        } catch (e) {
          // console.log(e)
        } finally {
          this.robotConnection = null
        }
      }
    },
  },
  async created() {
    this.initConenction()
    await this.getRobotList()
    if (this.robotHost) {
      this.robotChange()
    }
  },
  beforeDestroy() {
    this.disConnect()
    this.stopImgPlay()
    this.destroyNode()
  },
}
</script>

<style lang="scss" scoped>
.task-item {
  &:hover {
    .task-item-top {
      color: #31c8d4;
    }
    .task-item-bottom {
      color: #31c8d4 !important;
    }
  }
}
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      padding-left: 5px;
      padding-right: 5px;
      line-height: 14px;
    }
    th.el-table__cell > .cell {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
}
</style>
